export default __webpack_public_path__ + "static/media/logo-square.49796772.png";